// const API_BASE = `http://${window.location.hostname}:8000`;
const API_BASE = process.env.REACT_APP_API_URL;

export async function getImgOptions(options = {}) {
  const params = new URLSearchParams();

  if (options.imgName) {
    params.append("img_name", options.imgName);
  }
  
  if (options.description) {
    params.append("description", options.description);
  }

  if (options.uploaded_by) {
    params.append("uploaded_by", options.uploaded_by);
  }

  if (Array.isArray(options.people) && options.people.length > 0) {
    params.append("people", options.people.join(","));
  }

  if (options.dateFrom !== undefined) {
    params.append("date_from", String(options.dateFrom));
  }

  if (options.dateTo !== undefined) {
    params.append("date_to", String(options.dateTo));
  }

  if (options.sortBy) {
    params.append("sort_by", options.sortBy);
  }

  if (options.reunion) {
    params.append("reunion", options.reunion);
  }

  if (options.scroll_box) {
    params.append("scroll_box", options.scroll_box)
  }

  if (Array.isArray(options.sortByDate) && options.sortByDate.length > 0) {
    params.append("sort_by_date", options.sortByDate.join(","));
  }

  const url = `${API_BASE}/images?${params.toString()}`;
  const res = await fetch(url);

  if (!res.ok) {
    let errorMessage = "Failed to fetch images";

    try {
      const errorBody = await res.json();
      if (errorBody?.detail) {
        errorMessage = errorBody.detail;
      }
    } catch {
      // ignore JSON parse errors
    }

    throw new Error(errorMessage);
  }

  return res.json();
}
